import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Button } from 'reactstrap';
import { v4 as uuidV4 } from 'uuid';
import moment from 'moment';
import CertificationForm from './certificationForm';
import Icon from '../../common/containers/icon';
const EmployeeCertifications = _ref => {
  let _ref$certifications = _ref.certifications,
    propsCertifications = _ref$certifications === void 0 ? [] : _ref$certifications,
    onChange = _ref.onChange,
    userID = _ref.userID;
  const newItem = () => ({
    appCreatorID: userID,
    id: uuidV4().toUpperCase(),
    appCreated: moment().utc().format('YYYY-MM-DD HH:mm:ss')
  });
  const handleAdd = () => {
    const certs = JSON.parse(JSON.stringify(propsCertifications));
    certs.push(newItem());
    onChange('certifications', certs);
  };
  const handleChange = (index, name, value) => onChange("certifications[".concat(index, "]/").concat(name), value);
  const handleRemove = index => {
    const certifications = JSON.parse(JSON.stringify(propsCertifications));
    certifications.splice(index, 1);
    onChange('certifications', certifications);
  };
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("form", null, propsCertifications ? propsCertifications.map((certification, index) => /*#__PURE__*/React.createElement(CertificationForm, {
    key: certification.id,
    index: index,
    onChange: handleChange,
    onRemove: handleRemove,
    certification: certification
  })) : undefined), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    sm: {
      size: 3,
      offset: 9
    }
  }, /*#__PURE__*/React.createElement(Button, {
    size: "sm",
    onClick: handleAdd,
    className: "form-control t-ec-add-certification tqc-control"
  }, /*#__PURE__*/React.createElement(Icon, {
    glyph: "plus"
  }), " Add Certification"))));
};
EmployeeCertifications.propTypes = {
  userID: PropTypes.string.isRequired,
  certifications: PropTypes.arrayOf(PropTypes.shape({})),
  onChange: PropTypes.func.isRequired
};
export default EmployeeCertifications;